import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "../../../assets/loader.json";
import { Box, FlexBox } from "../../primitives";

const Loader = () => {
  return (
    <FlexBox
      style={{
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box css={{ width: 100, height: 100 }}>
        <Lottie animationData={loaderAnimation} loop={true} />
      </Box>
    </FlexBox>
  );
};

export default Loader;
